/**
 * Модуль плавной прокрутки к якорям
 */

import { scrollToElement } from '../utils/dom.js'

/**
 * Инициализирует плавную прокрутку к якорям
 */
export function initSmoothScrolling() {
  const anchorLinks = document.querySelectorAll('a[href^="#"]:not([href="#"])')

  if (!anchorLinks.length) return

  anchorLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault()

      const targetId = this.getAttribute('href')
      const targetElement = document.querySelector(targetId)

      if (!targetElement) return

      // Проверяем, открыто ли мобильное меню
      const mobileMenu = document.querySelector('.header__nav')
      const burgerButton = document.querySelector('.header__burger')

      // Если меню открыто, закрываем его
      if (mobileMenu?.classList.contains('header__nav--active')) {
        mobileMenu.classList.remove('header__nav--active')
        burgerButton?.classList.remove('header__burger--active')
        document.body.classList.remove('no-scroll')
      }

      // Получаем высоту хедера для корректировки прокрутки
      const header = document.querySelector('.header')
      const headerHeight = header ? header.offsetHeight : 0

      // Выполняем плавную прокрутку
      scrollToElement(targetElement, headerHeight, 'smooth')

      // Обновляем URL с хешем
      history.pushState(null, null, targetId)
    })
  })

  // Проверка хеша при загрузке страницы
  if (window.location.hash) {
    setTimeout(() => {
      const targetElement = document.querySelector(window.location.hash)

      if (targetElement) {
        const header = document.querySelector('.header')
        const headerHeight = header ? header.offsetHeight : 0

        scrollToElement(targetElement, headerHeight, 'smooth')
      }
    }, 100)
  }
}




